import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { formatDate } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { EntityManager } from "./EntityManager";

const Flag = ({ on, label }) => on ? <span className="badge-cat mr-1">{label}</span> : null;

const DEFAULTS = { title: "", category: "politique", author: "Rédaction Chronique.cd", excerpt: "", content: "", image_url: "", tags: [], is_featured: false, is_editors_pick: false, is_trending: false, in_ticker: false, published: true };

const buildFields = (categories) => [
  { name: "title", label: "Titre", required: true, full: true },
  { name: "category", label: "Rubrique", type: "select", options: categories.map((c) => ({ value: c.slug, label: c.name })) },
  { name: "author", label: "Auteur" },
  { name: "excerpt", label: "Chapô / résumé", type: "textarea", rows: 2, full: true },
  { name: "content", label: "Contenu (séparez les paragraphes par une ligne vide)", type: "textarea", rows: 12, full: true },
  { name: "image_url", label: "Photo principale", type: "file", accept: "image/*", placeholder: "Téléverser une photo…", full: true },
  { name: "is_featured", label: "À la une (carrousel)", type: "switch" },
  { name: "is_editors_pick", label: "Choix de la rédaction", type: "switch" },
  { name: "is_trending", label: "Tendance", type: "switch" },
  { name: "in_ticker", label: "Afficher dans le bandeau Flash infos", type: "switch" },
  { name: "published", label: "Publié", type: "switch" },
];

export default function ArticlesManager() {
  const [sp] = useSearchParams();
  const { categories, catName } = useSettings();
  const fields = useMemo(() => buildFields(categories), [categories]);
  const columns = useMemo(() => [
    { key: "title", label: "Titre", render: (a) => <div className="max-w-md"><div className="font-semibold line-clamp-1">{a.title}</div><div className="text-xs text-zinc-500">{a.author} · {formatDate(a.published_at)}</div></div> },
    { key: "category", label: "Rubrique", render: (a) => catName(a.category) },
    { key: "flags", label: "Mise en avant", render: (a) => <div className="flex flex-wrap gap-y-1"><Flag on={a.is_featured} label="Une" /><Flag on={a.is_editors_pick} label="Rédac" /><Flag on={a.is_trending} label="Tend." /><Flag on={a.in_ticker} label="Flash" /></div> },
    { key: "published", label: "Statut", render: (a) => <span className={`text-xs font-bold ${a.published ? "text-green-600" : "text-zinc-400"}`}>{a.published ? "Publié" : "Brouillon"}</span> },
    { key: "views", label: "Vues" },
  ], [catName]);
  const defaults = useMemo(() => ({ ...DEFAULTS, category: categories[0]?.slug || "politique" }), [categories]);

  return (
    <EntityManager title="Articles" description="Rédigez, illustrez et publiez les articles des rubriques." listUrl="/admin/articles" baseUrl="/articles" fields={fields} columns={columns} testId="articles" wide autoOpen={sp.get("new") === "1"} defaults={defaults} />
  );
}
